import { RouteComponentProps } from '@reach/router';
import { AppPath } from 'appConstants';

const UpgradeFreeSubscriptions: React.FC<RouteComponentProps> = () => {
   window.location.href = AppPath.NEW_SUBSCRIPTION;

  return <></>;
};

export default UpgradeFreeSubscriptions;


